export const getToken = () => {
	let TokenData = JSON.parse(window.IntellicarSSOWidget.default.getImpUserDetails());
	if (!TokenData.userInfo) {
		TokenData = JSON.parse(window.IntellicarSSOWidget.default.getRootUserDetails());
	}

	return TokenData.token;
};

export const getUserInfo = () => {
	let TokenData = JSON.parse(window.IntellicarSSOWidget.default.getImpUserDetails());
	if (!TokenData.userInfo) {
		TokenData = JSON.parse(window.IntellicarSSOWidget.default.getRootUserDetails());
	}

	return JSON.parse(TokenData.userInfo);
};
export const isUserImpersonated = () => {
	let TokenData = JSON.parse(window.IntellicarSSOWidget.default.getImpUserDetails());
	if (!TokenData.userInfo) {
		return false;
	} else {
		return true;
	}
};

export const getRootUserInfo = () => {
	return {};
};

export const getImpersonateUserInfo = () => {
	return {};
};
